module.exports = __webpack_public_path__ + "static/media/laas-s.a6b2e619.mp3";